module.exports = __webpack_public_path__ + "media/06.282a5724.mp4";